
(function(){
  const $=(s,c=document)=>c.querySelector(s);
  const $$=(s,c=document)=>Array.from(c.querySelectorAll(s));

  function initHeader(){
    const button=$('[data-mobile-menu-toggle]');
    const drawer=$('[data-mobile-drawer]');
    if(!button||!drawer)return;
    button.addEventListener('click',()=>{
      const open=drawer.classList.toggle('is-open');
      button.setAttribute('aria-expanded',String(open));
      document.body.classList.toggle('modal-open',open);
    });
    $$('a',drawer).forEach(a=>a.addEventListener('click',()=>{
      drawer.classList.remove('is-open');button.setAttribute('aria-expanded','false');document.body.classList.remove('modal-open');
    }));
  }

  function initVoice(){
    $$('[data-voice-player]').forEach(player=>{
      if(player.dataset.ready)return;player.dataset.ready='true';
      const button=$('[data-voice-play]',player);const audio=$('audio',player);const time=$('[data-audio-time]',player);
      if(!button)return;
      button.addEventListener('click',()=>{
        if(audio){
          if(audio.paused){audio.play().catch(()=>{});player.classList.add('is-playing');button.setAttribute('aria-label','Pause recording');}
          else{audio.pause();player.classList.remove('is-playing');button.setAttribute('aria-label','Play recording');}
        }else{
          player.classList.toggle('is-playing');button.setAttribute('aria-label',player.classList.contains('is-playing')?'Pause recording':'Play recording');
        }
      });
      if(audio){
        audio.addEventListener('timeupdate',()=>{if(!time)return;const f=n=>String(Math.floor(n)).padStart(2,'0');time.textContent=Math.floor(audio.currentTime/60)+':'+f(audio.currentTime%60)+' / '+Math.floor(audio.duration/60)+':'+f(audio.duration%60);});
        audio.addEventListener('ended',()=>{player.classList.remove('is-playing');button.setAttribute('aria-label','Play recording');});
      }
    });
  }

  function initProduct(){
    $$('[data-product-form]').forEach(form=>{
      if(form.dataset.ready)return;form.dataset.ready='true';
      const select=$('[data-variant-select]',form);const price=$('[data-product-price]',form.closest('.product-info'));const button=$('[data-add-to-cart]',form);
      if(!select||!button)return;
      const update=()=>{const option=select.options[select.selectedIndex];const available=option.dataset.available==='true';if(price)price.textContent=option.dataset.price||price.textContent;button.disabled=!available;button.textContent=available?(button.dataset.label||'Add to cart'):'Sold out';};
      select.addEventListener('change',update);update();
    });
  }

  function initSticky(){
    const sticky=$('[data-mobile-sticky]');if(!sticky)return;
    const update=()=>sticky.classList.toggle('show',window.scrollY>520);
    update();window.addEventListener('scroll',update,{passive:true});
  }

  function initAll(){initHeader();initVoice();initSticky();initProduct();}
  document.addEventListener('DOMContentLoaded',initAll);
  document.addEventListener('shopify:section:load',initAll);
})();


document.addEventListener('click', function(e){
  var btn=e.target.closest('[data-voice-play]'); if(!btn) return;
  var card=btn.closest('.voice-audio-card'); if(!card) return;
  var audio=card.querySelector('[data-voice-audio]');
  if(audio){ if(audio.paused){audio.play().catch(function(){});card.classList.add('playing')}else{audio.pause();card.classList.remove('playing')} }
});
(function () {
  var destinationHost = 'app.startmytrove.com';
  var attributionKeys = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'utm_id',
    'fbclid'
  ];

  function attributionParams() {
    var current = new URL(window.location.href);
    var params = new URLSearchParams();

    attributionKeys.forEach(function (key) {
      var value = current.searchParams.get(key);
      if (value) params.set(key, value);
    });

    return params;
  }

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;

    var link = event.target.closest('a[href]');
    if (!link) return;

    var destination;

    try {
      destination = new URL(link.href, window.location.href);
    } catch (_) {
      return;
    }

    if (destination.hostname !== destinationHost) return;

    attributionParams().forEach(function (value, key) {
      if (!destination.searchParams.has(key)) {
        destination.searchParams.set(key, value);
      }
    });

    link.href = destination.toString();

    if (
      window.Shopify &&
      window.Shopify.analytics &&
      typeof window.Shopify.analytics.publish === 'function'
    ) {
      window.Shopify.analytics.publish('trove:start_click', {
        destination: 'trove_app'
      });
    }
  }, true);
})();